"use client";

import posthog from "posthog-js";
import { useEffect } from "react";
import { authClient } from "@/lib/auth/client";

/**
 * Attaches the authenticated user to PostHog as soon as the session is
 * known, so any exception or event fired during onboarding (before profile
 * save) is attributed to the right person rather than the anon distinct id.
 */
export function PostHogIdentify() {
  const { data: session } = authClient.useSession();

  useEffect(() => {
    if (!session?.user?.id) return;
    posthog.identify(session.user.id, {
      email: session.user.email,
      // we don't always capture name at sign-up, so omit it if not present.
      ...(session.user.name ? { name: session.user.name } : {}),
    });
  }, [session?.user?.id, session?.user?.email, session?.user?.name]);

  return null;
}
